var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#F4F6F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_367_5004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6404 11.2109H13.4785C13.1693 11.2109 12.8727 11.3332 12.654 11.5508C12.4353 11.7684 12.3125 12.0636 12.3125 12.3713L12.3935 24.2097C12.3936 24.3132 12.4215 24.4149 12.4743 24.5041C12.5272 24.5933 12.603 24.6667 12.6941 24.7169C12.7851 24.7671 12.8879 24.7921 12.9919 24.7894C13.0959 24.7866 13.1973 24.7563 13.2855 24.7014L17.6405 21.9926L21.9962 24.7014C22.0844 24.7561 22.1857 24.7863 22.2896 24.7889C22.3935 24.7916 22.4962 24.7665 22.5871 24.7164C22.678 24.6662 22.7538 24.5928 22.8066 24.5037C22.8594 24.4146 22.8873 24.3131 22.8875 24.2097L22.8064 12.3713C22.8064 12.0636 22.6836 11.7684 22.4649 11.5508C22.2462 11.3332 21.9497 11.2109 21.6404 11.2109Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_5004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 18,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductWithBg);
export default __webpack_public_path__ + "static/media/product-with-bg.ca92ef09.svg";
export { ForwardRef as ReactComponent };